import { Row, Col, Card, Statistic, Spin, Button, Tooltip, Modal } from "antd";
import { ArrowUpOutlined, CloseOutlined, LoadingOutlined, ReloadOutlined } from "@ant-design/icons";
import { LuChartColumn, LuUserRoundSearch } from "react-icons/lu";
import { PiMicrosoftExcelLogoLight } from "react-icons/pi";
import { useState } from "react";
import SelecaoContexto from "../../SelecaoContexto";

const ResultCards = ({
  loading,
  mudarNome,
  ativas,
  suspenca,
  finalizadas,
  canceladas,
  total,
  situacaoOsFinalizadaParalegal,
  setIsExportExcel,
  setIsModalOsPorEstados,
  carregarLote
}) => {

  const [isModalClienteContexto, setIsModalClienteContexto] = useState(false);


  return (
    <>
    <div style={{ margin: "10px 0" }}>
      <Row gutter={14} className="margin-bottom">
        <Col span={2.5}>
          <Card variant="borderless" className="box-sh">
            {loading ? (
              <Spin indicator={<LoadingOutlined spin />} />
            ) : (
              <Statistic
                title={mudarNome}
                value={ativas}
                valueStyle={{ color: "#3990d3", fontSize: "16px", fontWeight: 600 }}
                prefix={<ArrowUpOutlined />}
              />
            )}
          </Card>
        </Col>

        <Col span={2.5}>
          <Card variant="borderless" className="box-sh">
            {loading ? (
              <Spin indicator={<LoadingOutlined spin />} />
            ) : (
              <Statistic
                title="Suspensas"
                value={suspenca}
                valueStyle={{ color: "rgb(255 179 0)", fontSize: "16px", fontWeight: 600 }}
                prefix={<ArrowUpOutlined />}
              />
            )}
          </Card>
        </Col>

        <Col span={2.5}>
          <Card
            variant="borderless"
            className="box-sh"
            style={{
              backgroundColor: "#fff",
              opacity: situacaoOsFinalizadaParalegal ? 0.5 : 1,
              pointerEvents: situacaoOsFinalizadaParalegal ? "none" : "auto",
              filter: situacaoOsFinalizadaParalegal ? "grayscale(50%)" : "none",
            }}
          >
            {loading ? (
              <Spin indicator={<LoadingOutlined spin />} />
            ) : (
              <Statistic
                title="Processo Concluído"
                value={finalizadas}
                valueStyle={{ color: "#3f8600", fontSize: "16px", fontWeight: 600 }}
                prefix={<ArrowUpOutlined />}
              />
            )}
          </Card>
        </Col>

        <Col span={2.5}>
          <Card variant="borderless" className="box-sh">
            {loading ? (
              <Spin indicator={<LoadingOutlined spin />} />
            ) : (
              <Statistic
                title="Canceladas"
                value={canceladas}
                valueStyle={{ color: "#004376", fontSize: "16px", fontWeight: 600 }}
                prefix={<ArrowUpOutlined />}
              />
            )}
          </Card>
        </Col>

        <Col span={2.5}>
          <Card variant="borderless" className="box-sh">
            {loading ? (
              <Spin indicator={<LoadingOutlined spin />} />
            ) : (
              <Statistic
                title="Total"
                value={total}
                valueStyle={{ color: "#005a9e", fontSize: "16px", fontWeight: 600 }}
                prefix={<ArrowUpOutlined />}
              />
            )}
          </Card>
        </Col>

        {/* Botões de ação */}
        <div
          style={{
            marginBottom: 10,
            display: "flex",
            justifyContent: "right",
          }}
        >

          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
             <Tooltip title="Seleção de Contexto">
              <div
                disabled={loading}
                className="btn-atualizar bt-blue-padrao"
                onClick={() => setIsModalClienteContexto(true)}
              >
                <LuUserRoundSearch />
              </div>
            </Tooltip>

            <Tooltip title="Exportar">
              <div
                disabled={loading}
                className="btn-atualizar bt-blue-padrao"
                onClick={() => setIsExportExcel(true)}
              >
                <PiMicrosoftExcelLogoLight />
              </div>
            </Tooltip>

            <Tooltip title="Gráfico de OS por estados">
              <div
                type="primary"
                disabled={loading}
                className="btn-atualizar bt-chart"
                onClick={() => setIsModalOsPorEstados(true)}
              >
                <LuChartColumn />
              </div>
            </Tooltip>

            <Tooltip title="Recarregar dados">
              <div
                type="primary"
                disabled={loading}
                className="btn-atualizar"
                onClick={loading ? null : carregarLote}
              >
                {loading ? (
                  <Spin indicator={<LoadingOutlined spin />} />
                ) : (
                  <ReloadOutlined />
                )}
              </div>

            </Tooltip>

          </div>
        </div>
      </Row>
    </div>

    <Modal title="Seleção de Contexto" width={"70%"} open={isModalClienteContexto} onCancel={() => setIsModalClienteContexto(false)} footer={null}>
      <SelecaoContexto/>
    </Modal>
    </>
  );
};

export default ResultCards;
